import React, { FC } from 'react';

import cn from '@/utils/cn';

interface Props {
  errorMessage?: string;
  className?: string;
}
const ErrorMessage: FC<Props> = ({ errorMessage, className }) => {
  return (
    <p
      aria-label="error-message"
      className={cn(
        'caption-large mt-1 w-full font-jakarta text-red-400',
        className
      )}
    >
      {errorMessage}
    </p>
  );
};

export default ErrorMessage;
